import {
  FiCpu, FiFileText, FiTrendingUp, FiBookOpen,
  FiShield, FiHeadphones, FiTarget, FiSettings
} from 'react-icons/fi';

const servicesData = [
  {
    slug: 'artificial-intelligence-intelligent-automation',
    num: '01',
    title: 'Artificial Intelligence & Intelligent Automation',
    shortTitle: 'AI & Intelligent Automation',
    kicker: 'SERVICE 01',
    icon: FiCpu,
    cardDesc: 'AI and Machine Learning solutions for large-scale data processes and repetitive decision-support activities.',
    heroDesc: 'DBH explores the application of Artificial Intelligence and Machine Learning for business processes involving large volumes of data and repetitive decision-support activities.',
    route: '/services/artificial-intelligence-intelligent-automation',
    metaTitle: 'Artificial Intelligence & Intelligent Automation | Data Bolta Hai',
    metaDesc: 'DBH provides AI-assisted data classification, document intelligence, NLP, predictive analytics, and intelligent workflow automation for businesses.',
    sections: [
      {
        type: 'feature-grid',
        heading: 'Our Areas Include',
        icon: 'pin',
        items: [
          { title: 'AI-assisted Data Classification', desc: 'Automated classification of data using machine learning models.' },
          { title: 'Document Intelligence', desc: 'Smart extraction and understanding of document content.' },
          { title: 'Natural Language Processing', desc: 'Text analysis, sentiment detection, and language understanding.' },
          { title: 'Intelligent Document Extraction', desc: 'Automated data extraction from structured and unstructured documents.' },
          { title: 'Transaction Pattern Recognition', desc: 'Identification of patterns and trends in transactional data.' },
          { title: 'Anomaly Detection', desc: 'Detection of unusual patterns and outliers in datasets.' },
          { title: 'Predictive Analytics', desc: 'Data-driven forecasting and predictive modelling.' },
          { title: 'AI-assisted Customer Communication', desc: 'Intelligent automation of customer interactions.' },
          { title: 'Automated Report Generation', desc: 'Auto-generated reports from processed data.' },
          { title: 'Intelligent Search & Retrieval', desc: 'Smart search and information retrieval systems.' },
          { title: 'AI-assisted Business Analysis', desc: 'AI-powered insights for business decision-making.' },
          { title: 'Rule-based & ML Workflows', desc: 'Combining rule engines with machine-learning workflows.' },
        ],
      },
      {
        type: 'ending',
        content: 'AI capabilities are applied with a focus on practical business use cases, data quality and process controls.',
      },
    ],
  },
  {
    slug: 'gst-reconciliation',
    num: '02',
    title: 'Advance GST Reconciliation (GST-Recon)',
    shortTitle: 'GST Reconciliation',
    kicker: 'SERVICE 02',
    icon: FiFileText,
    cardDesc: 'Powerful and advanced GST reconciliation process to reduce the burden of GST compliance and ensure 100% ITC claims.',
    heroDesc: 'We provide hassle free solutions, Most powerful and Advance GST Reconciliation process for our clients to reduce the burden of GST compliance.',
    route: '/services/gst-reconciliation',
    metaTitle: 'Advance GST Reconciliation (GST-Recon) | Data Bolta Hai',
    metaDesc: 'Advanced GST reconciliation solutions with auto-identification, multi-format support, ERP integration, and no data volume restrictions.',
    sections: [
      {
        type: 'paragraph',
        content: 'An objective outlook is core to our approach. To ensure that our clients derive true value through our services and that their needs are well-addressed, we work in partnership with legal advisory groups to implement court processes and also assist client teams with essential documentation whenever necessary.',
      },
      {
        type: 'feature-grid',
        heading: 'Unique Feature of GST – Advance Reconciliation',
        icon: 'check',
        items: [
          { title: 'Client-Specific Algorithms', desc: 'Special developed algorithms for import of Purchase Register and other required data, hence no specific template in data file required.' },
          { title: 'Any Data Format', desc: 'Support for Excel, PDF, RPT, TXT, Access and other file formats.' },
          { title: 'Structured & Unstructured Data', desc: 'Handling of both structured and unstructured data files.' },
          { title: 'Multiple Software Configuration', desc: 'Multiple software to configure for import data.' },
          { title: 'Direct ERP Linking', desc: 'Direct linking with existing ERP systems.' },
          { title: 'No Data Volume Restriction', desc: 'No restriction on data volume from 1 Lakh to Crores of line items.' },
        ],
      },
    ],
  },
  {
    slug: 'stock-market-data-analysis',
    num: '03',
    title: 'Stock Market Data Analysis (NSE & BSE)',
    shortTitle: 'Market Intelligence',
    kicker: 'SERVICE 03',
    icon: FiTrendingUp,
    cardDesc: 'Analysis of large-scale NSE and BSE equity trade data to identify patterns associated with market abuse and abnormal profitability.',
    heroDesc: 'We analyze large-scale NSE and BSE equity trade data at tick-by-tick and trade-level granularity to identify patterns associated with market abuse and abnormal profitability.',
    route: '/services/stock-market-data-analysis',
    metaTitle: 'Stock Market Data Analysis (NSE & BSE) | Data Bolta Hai',
    metaDesc: 'Forensic analysis of NSE and BSE trade data for front-running detection, profitability analysis, anomaly detection, and enforcement intelligence.',
    sections: [
      {
        type: 'feature-grid',
        heading: 'Core Capabilities (Operational)',
        icon: 'arrow',
        items: [
          { title: 'Front-Running Detection', desc: 'Identification of accounts earning abnormal profits through intraday or same-day square-off trades executed ahead of price or volume movements.' },
          { title: 'PAN / Account-Level Profitability Analysis', desc: 'Period-wise profit consistency analysis to flag abnormally profitable entities and clusters.' },
          { title: 'Abnormal Price & Volume Spike Detection', desc: 'Detection of sudden, unexplained price and volume movements inconsistent with normal market behavior.' },
        ],
      },
      {
        type: 'feature-grid',
        heading: 'Advanced Forensic Modules (Roadmap)',
        icon: 'pin',
        items: [
          { title: 'Operator / Cartel Detection', desc: 'Detection through coordinated trading patterns.' },
          { title: 'Insider-like Trading Pattern Identification', desc: 'Pattern identification prior to sensitive events.' },
          { title: 'Price Manipulation Detection', desc: 'Ramp-and-dump and circular trading detection.' },
          { title: 'Delivery-based Accumulation & Exit Analysis', desc: 'Analysis of delivery-based accumulation and exit patterns.' },
        ],
      },
      {
        type: 'feature-grid',
        heading: 'Analytical Approach',
        icon: 'check',
        items: [
          { title: 'Trade Flow Reconstruction', desc: 'Complete trade flow reconstruction to preserve chronology and context.' },
          { title: 'Statistical & Network Techniques', desc: 'Statistical, clustering, and network-based techniques to detect coordination and anomalies.' },
          { title: 'Profit Quantification', desc: 'Quantification of intraday and delivery-based profits and indicative retail impact.' },
          { title: 'Risk Scoring', desc: 'Risk scoring to prioritize scripts and accounts for investigation.' },
        ],
      },
      {
        type: 'feature-grid',
        heading: 'Scale & Performance',
        icon: 'arrow',
        items: [
          { title: 'Large-Scale Processing', desc: 'Designed to process hundreds of crore trade records.' },
          { title: 'High-Performance Computing', desc: 'Optimized for high-performance and parallel data processing.' },
          { title: 'Flexible Deployment', desc: 'Suitable for both case-specific investigations and market-wide surveillance.' },
        ],
      },
      {
        type: 'feature-grid',
        heading: 'Outputs to Agencies',
        icon: 'pin',
        items: [
          { title: 'Executive Summaries', desc: 'Executive summaries and risk-scored watchlists.' },
          { title: 'Visual Evidence', desc: 'Trade timelines and visual evidence including price-volume overlays and heatmaps.' },
          { title: 'Evidence-Ready Tables', desc: 'Evidence-ready statistical tables for further inquiry.' },
        ],
      },
      {
        type: 'feature-grid',
        heading: 'Value to Enforcement Agencies',
        icon: 'check',
        items: [
          { title: 'Actionable Intelligence', desc: 'Converts raw exchange data into actionable intelligence.' },
          { title: 'Case Prioritization', desc: 'Enables prioritization of high-risk cases.' },
          { title: 'Auditable Analysis', desc: 'Provides defensible, auditable, and reproducible analysis suitable for regulatory review and enforcement workflows.' },
        ],
      },
      {
        type: 'paragraph',
        heading: 'Engagement Model',
        content: 'Pilot studies on selected scripts/accounts, followed by joint review and scalable deployment aligned to agency requirements.',
      },
    ],
  },
  {
    slug: 'bank-narration-intelligence',
    num: '04',
    title: 'Bank Narration Intelligence and Transaction Analysis',
    shortTitle: 'Bank Narration Intelligence',
    kicker: 'SERVICE 04',
    icon: FiBookOpen,
    cardDesc: 'Converting raw, semi-structured bank narration strings into structured financial attributes for deeper transaction intelligence.',
    heroDesc: 'We believe that modern bank statements are more than simple debit-credit ledgers; they contain rich transactional intelligence embedded within narration text.',
    route: '/services/bank-narration-intelligence',
    metaTitle: 'Bank Narration Intelligence & Transaction Analysis | Data Bolta Hai',
    metaDesc: 'Deep narration analysis converting bank statement text into structured data for credit underwriting, fraud investigation, and spend analysis.',
    sections: [
      {
        type: 'paragraph',
        heading: 'Our Core Expertise',
        content: 'We specialize in Deep Narration Analysis. While manual interpretation of bank statements is time-consuming, error-prone, and non-scalable, our system automates the decomposition of complex narration text into clear, actionable data points.',
      },
      {
        type: 'feature-grid',
        heading: 'Key Capabilities',
        icon: 'pin',
        items: [
          { title: 'Narration Decomposition', desc: 'We logically split raw text into derived fields, including Payment Mode, Party Name, and Transaction Purpose.' },
          { title: 'Party & Counterparty Identification', desc: 'We extract specific merchant names, beneficiaries, and employers, even when obscured by abbreviations or mixed with payment indicators like UPI, NEFT, or IMPS.' },
          { title: 'Purpose Classification', desc: 'Going beyond the "what," we identify the "why" by classifying transactions into natures such as Salary, EMI, Utilities, Subscriptions, and Tax payments.' },
          { title: 'Traceability', desc: 'We capture critical UTR and Reference numbers to ensure unique transaction traceability for audit and dispute resolution.' },
        ],
      },
      {
        type: 'feature-grid',
        heading: 'Strategic Value',
        icon: 'check',
        items: [
          { title: 'Credit Underwriting & Financial Due Diligence', desc: 'Deep, auditable insights for credit assessment.' },
          { title: 'Fraud Investigation & Bank Reconciliation', desc: 'Transaction-level intelligence for fraud detection.' },
          { title: 'Tax Audit & Regulatory Reporting', desc: 'Structured data for compliance and reporting.' },
          { title: 'Spend Analysis', desc: 'Identifying top merchants and recurring expenses.' },
        ],
      },
    ],
  },
  {
    slug: 'dpdp-compliance',
    num: '05',
    title: 'Digital Personal Data Protection (DPDP) Compliance',
    shortTitle: 'DPDP & Data Privacy',
    kicker: 'SERVICE 05',
    icon: FiShield,
    cardDesc: 'Assisting organisations in understanding and implementing data-protection processes relevant to their operations.',
    heroDesc: 'DBH can assist organisations in understanding and implementing data-protection processes relevant to their operations.',
    route: '/services/dpdp-compliance',
    metaTitle: 'DPDP Compliance & Data Privacy Management | Data Bolta Hai',
    metaDesc: 'Comprehensive DPDP compliance services including data discovery, privacy governance, consent management, and technology enablement.',
    sections: [
      {
        type: 'feature-grid',
        heading: 'Data Discovery & Mapping',
        icon: 'arrow',
        items: [
          { title: 'Identification of Personal Data', desc: 'Systematic identification of personal data across the organisation.' },
          { title: 'Data Inventory', desc: 'Comprehensive data inventory creation.' },
          { title: 'Data-Flow Mapping', desc: 'Mapping how data flows through the organisation.' },
          { title: 'Data Collection Points', desc: 'Identification of all data collection points.' },
          { title: 'Data Processing Activities', desc: 'Mapping of data processing activities.' },
          { title: 'Third-Party Data Sharing', desc: 'Identification of third-party data sharing arrangements.' },
        ],
      },
      {
        type: 'feature-grid',
        heading: 'Privacy Governance',
        icon: 'pin',
        items: [
          { title: 'Data Privacy Framework', desc: 'Establishment of a comprehensive privacy framework.' },
          { title: 'Privacy Policies & Procedures', desc: 'Development of privacy policies and procedures.' },
          { title: 'Data Governance Framework', desc: 'Setting up data governance structures.' },
          { title: 'Roles & Responsibilities', desc: 'Defining roles and responsibilities for data protection.' },
          { title: 'Data-Handling Procedures', desc: 'Internal data-handling procedures.' },
          { title: 'Data-Retention Framework', desc: 'Framework for data retention and disposal.' },
          { title: 'Access & Control Procedures', desc: 'Access control and data security procedures.' },
        ],
      },
      {
        type: 'feature-grid',
        heading: 'Consent & Data Subject Processes',
        icon: 'check',
        items: [
          { title: 'Consent Management', desc: 'Consent management processes and records.' },
          { title: 'Notice & Communication', desc: 'Notice and communication processes.' },
          { title: 'Data Principal Request Management', desc: 'Management of data principal requests.' },
          { title: 'Data Correction Workflows', desc: 'Data correction and related workflows.' },
          { title: 'Grievance Management', desc: 'Grievance-management processes.' },
        ],
      },
      {
        type: 'feature-grid',
        heading: 'Risk & Compliance Assessment',
        icon: 'arrow',
        items: [
          { title: 'Data-Processing Assessment', desc: 'Assessment of data processing activities.' },
          { title: 'Privacy-Gap Assessment', desc: 'Identification of privacy gaps.' },
          { title: 'Risk Identification', desc: 'Systematic risk identification.' },
          { title: 'Compliance Review', desc: 'Process-level compliance review.' },
          { title: 'Vendor/Third-Party Assessment', desc: 'Vendor and third-party data assessment.' },
          { title: 'Compliance Documentation', desc: 'Comprehensive compliance documentation.' },
          { title: 'Periodic Monitoring', desc: 'Periodic compliance monitoring.' },
        ],
      },
      {
        type: 'feature-grid',
        heading: 'Technology Enablement',
        icon: 'pin',
        items: [
          { title: 'Data Discovery & Classification', desc: 'Technology solutions for data discovery and classification.' },
          { title: 'Consent Management Systems', desc: 'Automated consent management platforms.' },
          { title: 'Privacy Workflow Automation', desc: 'Automation of privacy-related workflows.' },
          { title: 'Data-Access Controls', desc: 'Technology-enabled access controls.' },
          { title: 'Audit Trails', desc: 'Comprehensive audit trail systems.' },
          { title: 'Compliance Dashboards', desc: 'Real-time compliance monitoring dashboards.' },
          { title: 'Data-Retention Monitoring', desc: 'Automated data-retention monitoring.' },
          { title: 'Privacy Reporting', desc: 'Automated privacy reporting tools.' },
        ],
      },
      {
        type: 'ending',
        content: 'The DPDP practice is intended to combine compliance requirements with practical technology and process implementation.',
      },
    ],
  },
  {
    slug: 'call-centre-customer-service-automation',
    num: '06',
    title: 'Call Centre & Customer Service Automation',
    shortTitle: 'Call Centre Automation',
    kicker: 'SERVICE 06',
    icon: FiHeadphones,
    cardDesc: 'AI-enabled customer communication and call centre automation to improve efficiency while reducing repetitive manual activities.',
    heroDesc: 'DBH also works in the area of Call Centre Automation and AI-enabled customer communication.',
    route: '/services/call-centre-customer-service-automation',
    metaTitle: 'Call Centre & Customer Service Automation | Data Bolta Hai',
    metaDesc: 'Automated customer enquiry handling, AI-assisted communication, call workflow automation, and CRM integration solutions.',
    sections: [
      {
        type: 'feature-grid',
        heading: 'Potential Solutions',
        icon: 'check',
        items: [
          { title: 'Automated Customer Enquiry Handling', desc: 'Intelligent automation of customer enquiries.' },
          { title: 'AI-assisted Customer Communication', desc: 'AI-powered customer interaction management.' },
          { title: 'Call Workflow Automation', desc: 'Streamlined call processing workflows.' },
          { title: 'Customer Follow-up Automation', desc: 'Automated follow-up processes.' },
          { title: 'Lead Follow-up', desc: 'Systematic lead follow-up automation.' },
          { title: 'Appointment/Reminder Communication', desc: 'Automated appointment and reminder notifications.' },
          { title: 'Customer Query Classification', desc: 'Intelligent classification of customer queries.' },
          { title: 'Automated Call Routing', desc: 'Smart call routing based on query type.' },
          { title: 'Customer Interaction Records', desc: 'Comprehensive interaction record keeping.' },
          { title: 'Call-centre MIS & Analytics', desc: 'Performance metrics and analytics dashboards.' },
          { title: 'Agent Performance Analytics', desc: 'Agent-level performance tracking.' },
          { title: 'Customer Interaction Analysis', desc: 'Deep analysis of customer interactions.' },
          { title: 'Automated Escalation Workflows', desc: 'Intelligent escalation management.' },
          { title: 'CRM Integration', desc: 'Seamless integration with CRM systems.' },
          { title: 'Voice & Text Communication', desc: 'Multi-channel voice and text-based communication.' },
        ],
      },
      {
        type: 'ending',
        content: 'These solutions can be configured for different industries and business processes rather than being restricted to a particular sector.',
      },
    ],
  },
  {
    slug: 'digital-marketing-customer-engagement',
    num: '07',
    title: 'Digital Marketing & Customer Engagement',
    shortTitle: 'Digital Marketing',
    kicker: 'SERVICE 07',
    icon: FiTarget,
    cardDesc: 'Data-driven digital marketing and customer engagement solutions integrated with analytics and automation.',
    heroDesc: 'DBH provides Digital Marketing and Customer Engagement solutions.',
    route: '/services/digital-marketing-customer-engagement',
    metaTitle: 'Digital Marketing & Customer Engagement | Data Bolta Hai',
    metaDesc: 'Digital marketing strategy, lead generation, campaign analytics, customer segmentation, and performance monitoring solutions.',
    sections: [
      {
        type: 'feature-grid',
        heading: 'Our Services Can Include',
        icon: 'arrow',
        items: [
          { title: 'Digital Marketing Strategy', desc: 'Comprehensive digital marketing strategy development.' },
          { title: 'Online Brand Presence', desc: 'Strengthening online brand visibility.' },
          { title: 'Lead-generation Support', desc: 'Targeted lead generation campaigns.' },
          { title: 'Customer Acquisition Campaigns', desc: 'Customer acquisition strategy and execution.' },
          { title: 'Digital Communication', desc: 'Multi-channel digital communication.' },
          { title: 'Customer Engagement', desc: 'Customer engagement optimization.' },
          { title: 'Campaign Analytics', desc: 'Performance tracking and analytics.' },
          { title: 'Marketing Data Analytics', desc: 'Data-driven marketing insights.' },
          { title: 'Customer Segmentation', desc: 'Intelligent customer segmentation.' },
          { title: 'Lead Management', desc: 'End-to-end lead management.' },
          { title: 'Customer Follow-up Automation', desc: 'Automated follow-up processes.' },
          { title: 'Digital Campaign Reporting', desc: 'Comprehensive campaign reporting.' },
          { title: 'Performance Monitoring', desc: 'Real-time performance monitoring.' },
        ],
      },
      {
        type: 'ending',
        content: 'Our digital marketing capabilities can be integrated with data analytics and automation to provide organisations with a more measurable and technology-driven customer engagement framework.',
      },
    ],
  },
  {
    slug: 'automation-process-digitisation-mis',
    num: '08',
    title: 'Automation & Process Digitisation - MIS',
    shortTitle: 'Process Automation & MIS',
    kicker: 'SERVICE 08',
    icon: FiSettings,
    cardDesc: 'Converting repetitive processes into technology-enabled workflows for measurable benefits in time, accuracy, and scalability.',
    heroDesc: 'DBH helps organisations identify repetitive processes and convert them into technology-enabled workflows.',
    route: '/services/automation-process-digitisation-mis',
    metaTitle: 'Automation & Process Digitisation - MIS | Data Bolta Hai',
    metaDesc: 'Process automation, data-entry automation, workflow automation, API integration, and AI-assisted document processing solutions.',
    sections: [
      {
        type: 'feature-grid',
        heading: 'Our Automation Capabilities Include',
        icon: 'pin',
        items: [
          { title: 'Process Automation', desc: 'End-to-end process automation solutions.' },
          { title: 'Data-entry Automation', desc: 'Elimination of manual data entry.' },
          { title: 'Document-processing Automation', desc: 'Automated document processing workflows.' },
          { title: 'Report-generation Automation', desc: 'Automated report generation systems.' },
          { title: 'Reconciliation Automation', desc: 'Automated reconciliation processes.' },
          { title: 'Workflow Automation', desc: 'Streamlined workflow automation.' },
          { title: 'Automated Data Extraction', desc: 'Intelligent data extraction from various sources.' },
          { title: 'Automated Validation', desc: 'Automated data validation processes.' },
          { title: 'Automated Exception Reporting', desc: 'Intelligent exception detection and reporting.' },
          { title: 'API-based Data Integration', desc: 'Seamless API-based data integration.' },
          { title: 'AI-assisted Document Processing', desc: 'AI-powered document processing.' },
          { title: 'Rule-based Transaction Processing', desc: 'Rule-based automated transaction processing.' },
        ],
      },
      {
        type: 'ending',
        content: 'We focus on automation that provides measurable benefits in terms of time, accuracy, scalability and operational control.',
      },
    ],
  },
];

export default servicesData;
